(() => {
  const initHeader = () => {
    const header = document.querySelector('[data-fb-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    const menu = header.querySelector('.fb-menu');
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    new ResizeObserver(() => document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`)).observe(header);
  };
  const initPurchase = () => {
    const source = document.querySelector('.Product .ProductForm__AddToCart');
    const bar = document.querySelector('[data-fb-sticky]');
    if (!source || !bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const button = bar.querySelector('button');
    const price = bar.querySelector('[data-fb-price]');
    let aboveOptions = false;
    const sync = () => {
      button.textContent = aboveOptions && !source.disabled ? bar.dataset.choose : source.textContent.trim();
      button.disabled = source.disabled;
      const currentPrice = document.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
      if (currentPrice) price.textContent = currentPrice.textContent.trim();
    };
    sync();
    new MutationObserver(sync).observe(source, {childList: true, subtree: true, attributes: true});
    const meta = document.querySelector('.ProductMeta__PriceList');
    if (meta) new MutationObserver(sync).observe(meta, {childList: true, subtree: true, characterData: true});
    new IntersectionObserver(entries => {
      const entry = entries[0];
      aboveOptions = entry.boundingClientRect.top > innerHeight;
      const visible = !entry.isIntersecting && (entry.boundingClientRect.bottom < 0 || (aboveOptions && matchMedia('(max-width: 767px)').matches));
      bar.hidden = !visible;
      document.body.classList.toggle('fb-has-sticky', visible);
      sync();
    }, {threshold: 0}).observe(source);
    let scrollFrame = 0;
    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        const rect = source.getBoundingClientRect();
        aboveOptions = rect.top > innerHeight;
        const visible = rect.bottom < 0 || (aboveOptions && matchMedia('(max-width: 767px)').matches);
        bar.hidden = !visible;
        document.body.classList.toggle('fb-has-sticky', visible);
        sync();
      });
    }, {passive: true});
    button.addEventListener('click', () => {
      if (aboveOptions) {
        const options = document.querySelector('.ProductForm__Variants') || source;
        options.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
        return;
      }
      if (!source.disabled) source.click();
    });
  };
  const initGallery = () => {
    document.querySelectorAll('.Product__SlideshowNav--thumbnails').forEach(nav => {
      if(nav.dataset.fbGallery) return;
      const scroller=nav.querySelector('.Product__SlideshowNavScroller');
      if(!scroller) return;
      nav.dataset.fbGallery='true';
      const home=document.createComment('Thumbnail gallery position');nav.before(home);
      const wrapper=nav.closest('.Product__Wrapper'),desktop=matchMedia('(min-width:1008px)');
      const previous=document.createElement('button'),next=document.createElement('button');
      [previous,next].forEach((button,i)=>{button.type='button';button.className='fb-gallery-edge '+(i?'fb-gallery-next':'fb-gallery-prev');button.setAttribute('aria-label',i?'Next product photos':'Previous product photos');button.textContent=i?'›':'‹';nav.append(button);button.onclick=()=>scroller.scrollBy({left:(i?1:-1)*scroller.clientWidth*.7,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
      const bounds=()=>{previous.disabled=scroller.scrollLeft<=2;next.disabled=scroller.scrollLeft+scroller.clientWidth>=scroller.scrollWidth-2;nav.classList.toggle('fb-gallery-overflow',scroller.scrollWidth>scroller.clientWidth+2);};
      const place=()=>{if(desktop.matches)wrapper.append(nav);else home.after(nav);bounds();};
      desktop.addEventListener('change',place);place();
      scroller.addEventListener('scroll',bounds,{passive:true});new ResizeObserver(bounds).observe(scroller);
      let drag=null,suppressClick=false;
      scroller.addEventListener('dragstart',event=>{if(desktop.matches)event.preventDefault();});
      scroller.addEventListener('pointerdown',event=>{
        if(!desktop.matches||event.pointerType!=='mouse'||event.button!==0)return;
        drag={x:event.clientX,left:scroller.scrollLeft,moved:false};suppressClick=false;
      });
      window.addEventListener('pointermove',event=>{
        if(!drag)return;
        const delta=event.clientX-drag.x;
        if(Math.abs(delta)>6)drag.moved=true;
        if(drag.moved){event.preventDefault();scroller.classList.add('is-dragging');scroller.scrollLeft=drag.left-delta;}
      });
      const endDrag=()=>{
        if(!drag)return;
        suppressClick=drag.moved;drag=null;scroller.classList.remove('is-dragging');
        setTimeout(()=>{suppressClick=false;},0);
      };
      window.addEventListener('pointerup',endDrag);
      window.addEventListener('pointercancel',endDrag);
      scroller.addEventListener('click',event=>{
        if(suppressClick){event.preventDefault();event.stopImmediatePropagation();}
      },true);
    });
  };
  const initCompactPurchase = () => {
    document.querySelectorAll('.ProductForm').forEach(form=>{
      const quantity=form.querySelector('.ProductForm__QuantitySelector'),buy=form.querySelector('.ProductForm__BuyButtons');
      if(!quantity||!buy||form.querySelector('.fb-purchase-row'))return;
      const row=document.createElement('div');row.className='fb-purchase-row';buy.before(row);row.append(quantity,buy);
      const help=buy.querySelector('.fb-purchase-help');if(help)row.after(help);
      const rating=form.querySelector('.loox-rating');
      if(rating){const label=document.createElement('span');label.className='fb-product-review-label';label.textContent='Product reviews';rating.before(label);}
    });
  };
  const mountReviewFeed=(panel,frame,productId,close)=>{
    const labels=document.querySelector('#fb-review-labels')?.dataset||{};
    const requestedReview=pendingReviewId;pendingReviewId=null;
    panel.querySelectorAll('.loox-iframe-focus-trap').forEach(trap=>trap.remove());
    const feed=document.createElement('div');feed.className='fb-review-feed';
    const status=document.createElement('p');status.className='fb-review-status';status.setAttribute('role','status');status.textContent=labels.loading;
    const widget=document.createElement('loox-reviews-widget');
    widget.setAttribute('client-id',window.LOOX.clientId);
    widget.setAttribute('surface',productId?'product':'aggregate');
    if(productId)widget.setAttribute('product-id',productId);
    widget.setAttribute('product-thumbnails','true');
    const preset=document.createElement('lxrw-widget-preset');widget.append(preset);
    feed.append(status,widget);frame.replaceWith(feed);
    let detail=null,lastCard=null;
    const backToList=()=>{if(!detail)return;detail.remove();detail=null;widget.hidden=false;lastCard?.focus({preventScroll:true});};
    const showReview=(review,card)=>{
      if(review.media?.some(media=>media.type!=='photo')){window.LOOX.openQV(review._id);return;}
      backToList();lastCard=card;widget.hidden=true;
      detail=document.createElement('section');detail.className='fb-review-detail';detail.dataset.reviewId=review._id;
      const back=document.createElement('button');back.type='button';back.className='fb-review-back';back.textContent=labels.back;back.onclick=backToList;
      const body=document.createElement('div');body.className='fb-review-detail-body';
      const photos=document.createElement('div');photos.className='fb-review-detail-photos';
      (review.media||[]).forEach(media=>{const img=document.createElement('img');img.src=new URL(media.image,location.href).href;img.alt=media.altText||'';img.loading='lazy';photos.append(img);});
      const copy=document.createElement('div');copy.className='fb-review-detail-copy';
      const name=document.createElement('h3');name.textContent=review.nickname;
      const meta=document.createElement('p');meta.className='fb-review-meta';meta.textContent=new Date(review.date).toLocaleDateString(document.documentElement.lang||'en')+(review.verified?' · '+labels.verified:'');
      const stars=document.createElement('p');stars.className='fb-review-stars';stars.textContent='★'.repeat(review.rating)+'☆'.repeat(5-review.rating);stars.setAttribute('aria-label',review.rating+' / 5');
      const quote=document.createElement('p');quote.className='fb-review-quote';quote.textContent=review.review;
      copy.append(name,meta,stars,quote);
      if(review.incentivized){const incentive=document.createElement('small');incentive.textContent=labels.incentive;copy.append(incentive);}
      if(review.reply){const reply=document.createElement('p');reply.textContent=typeof review.reply==='string'?review.reply:review.reply.text||review.reply.content||'';copy.append(reply);}
      if(review.product?.handle){const link=document.createElement('a');link.className='fb-review-product';link.href='/products/'+encodeURIComponent(review.product.handle);link.textContent=review.product.name;copy.append(link);}
      if(photos.children.length)body.append(photos);else body.classList.add('fb-review-text-only');
      body.append(copy);detail.append(back,body);feed.append(detail);feed.scrollTop=0;back.focus({preventScroll:true});
    };
    const openCard=event=>{
      const card=event.composedPath().find(node=>node.localName==='lxrw-review-card'||node.localName==='lxrw-store-review-card');
      if(!card||event.composedPath().some(node=>node.localName==='a'))return;
      if(event.type==='keydown'&&!['Enter',' '].includes(event.key))return;
      const review=widget.reviews?.find(item=>item._id===card.dataset.id);
      if(!review)return;
      event.preventDefault();event.stopImmediatePropagation();showReview(review,card);
    };
    widget.addEventListener('click',openCard,true);widget.addEventListener('keydown',openCard,true);
    const fallback=()=>{if(!panel.isConnected)return;feed.replaceWith(frame);panel.classList.add('fb-review-legacy');};
    panel.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const items=[];
      const scan=root=>{[...root.children].forEach(el=>{
        if(el.hidden||getComputedStyle(el).display==='none')return;
        if(el.matches('button:not([disabled]),a[href],[tabindex="0"]')&&el.getClientRects().length)items.push(el);
        if(el.shadowRoot)scan(el.shadowRoot);
        scan(el);
      });};
      scan(panel);
      const active=event.composedPath()[0],first=items[0],last=items[items.length-1];
      if(event.shiftKey&&active===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&active===last){event.preventDefault();first?.focus();}
    });
    const deadline=Date.now()+15000;
    const ready=()=>{
      if(!panel.isConnected)return;
      if(widget.reviews?.length){
        status.remove();
        if(requestedReview){const review=widget.reviews.find(item=>item._id===requestedReview);if(review)showReview(review,close);else window.LOOX.openQV(requestedReview);}
        return;
      }
      if(Date.now()>deadline){fallback();return;}
      setTimeout(ready,150);
    };
    ready();
  };
  let pendingReviewId=null;
  const initReviews = () => {
    if(!document.querySelector('loox-trust-badge-widget')&&!document.body.dataset.fbReviewWatch){
      document.body.dataset.fbReviewWatch='true';
      const watcher=new MutationObserver(()=>{if(document.querySelector('loox-trust-badge-widget')){watcher.disconnect();initReviews();}});
      watcher.observe(document.body,{childList:true,subtree:true});
    }
    const surface=document.querySelector('.fb-review-surface');
    if(surface&&!surface.dataset.fbReady){
      surface.dataset.fbReady='true';surface.hidden=true;
      document.querySelectorAll('a[href="#looxReviews"]').forEach(link=>{
        link.setAttribute('aria-haspopup','dialog');
        link.addEventListener('click',event=>{
          if(typeof window.LOOX?.openHCFloater==='function'){
            event.preventDefault();event.stopImmediatePropagation();
            window.LOOX.openHCFloater(surface.querySelector('[data-product-id]').dataset.productId);
          }else{surface.hidden=false;}
        },true);
      });
    }
    document.querySelectorAll('loox-trust-badge-widget').forEach(widget=>{
      if(widget.closest('.fb-store-proof'))return;
      const panel=document.createElement('div');panel.className='fb-store-proof';
      const labels=document.querySelector('#fb-review-labels')?.dataset;
      const shop=document.createElement('small');shop.className='fb-store-shop';shop.textContent=labels?.shop||'Spirit Magicka Crystal Shop';
      const label=document.createElement('p');label.textContent=labels?.heading||'Loved by the metaphysical community';
      widget.before(panel);panel.append(shop,label,widget);
      const photos=document.querySelector('#fb-store-photo-template');
      if(photos)panel.append(photos.content.cloneNode(true));
      const read=document.createElement('button');read.type='button';read.className='fb-read-reviews';
      read.textContent=labels?.read||'Read reviews';read.setAttribute('aria-haspopup','dialog');panel.append(read);
      read.addEventListener('click',()=>{if(window.LOOX?.openHCFloater){LOOX.lastActiveEl=read;LOOX.openHCFloater();}});
      panel.querySelectorAll('[data-fb-review-id]').forEach(button=>button.addEventListener('click',()=>{
        if(window.LOOX?.openQV){LOOX.lastActiveEl=button;pendingReviewId=button.dataset.fbReviewId;LOOX.openHCFloater();}
      }));
    });
    if(!document.body.dataset.fbReviewClose){
      document.body.dataset.fbReviewClose='true';
      let reviewReturnFocus=null;
      const closeAllReviews=()=>{
        const back=reviewReturnFocus;
        [...document.querySelectorAll('.loox-overlay')].reverse().forEach(layer=>{
          window.LOOX?.closeModal(layer.id.replace('looxOverlay_',''));
        });
        // Native quickviews can update activeFrame while closing: leave no review layer behind.
        document.querySelectorAll('.loox-overlay').forEach(layer=>layer.remove());
        document.body.classList.remove('loox-overlay-is-active','fb-review-open');
        document.body.style.overflow='';document.body.style.position='';
        if(window.LOOX){LOOX.activeFrame=null;LOOX.lastActiveEl=null;}
        reviewReturnFocus=null;
        if(back?.isConnected)back.focus({preventScroll:true});
      };
      const updateClose=()=>{
        const overlays=[...document.querySelectorAll('.loox-overlay')];
        const trigger=window.LOOX?.lastActiveEl||document.activeElement;
        if(overlays.length&&!reviewReturnFocus&&!trigger?.closest('.loox-overlay'))reviewReturnFocus=trigger;
        if(!overlays.length)reviewReturnFocus=null;
        document.body.classList.toggle('fb-review-open',overlays.length>0);
        overlays.forEach((overlay,index)=>{
          overlay.classList.toggle('fb-review-underlay',index<overlays.length-1);
          if(overlay.querySelector('.fb-review-close'))return;
          const panel=overlay.querySelector(':scope > div'),close=document.createElement('button');
          if(!panel)return;
          panel.classList.add('fb-review-panel');
          overlay.setAttribute('role','dialog');
          overlay.setAttribute('aria-label',overlay.querySelector('iframe')?.title||'Customer reviews');
          close.type='button';close.className='fb-review-close';
          close.textContent=(document.querySelector('#fb-review-labels')?.dataset.close||'Close reviews')+' ×';
          close.onclick=closeAllReviews;
          const labels=document.querySelector('#fb-review-labels')?.dataset;
          const frame=panel.querySelector('iframe');
          const productId=frame?new URL(frame.src).searchParams.get('productIds'):null;
          const heading=document.createElement('div');heading.className='fb-review-heading';
          const title=document.createElement('strong');title.textContent=productId?labels?.productTitle:labels?.allTitle;
          const subtitle=document.createElement('span');subtitle.textContent=labels?.shop;
          heading.append(title,subtitle);panel.append(heading,close);
          if(frame?.id==='looxModalFrame')mountReviewFeed(panel,frame,productId,close);
          close.focus({preventScroll:true});
          overlay.addEventListener('click',event=>{if(event.target===overlay)closeAllReviews();});
          overlay.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close.click();}});
        });
      };
      new MutationObserver(updateClose).observe(document.body,{childList:true,subtree:true});updateClose();
    }
  };
  const initHelp = () => {
    document.querySelectorAll('.fb-purchase-help').forEach(help => {
      if(help.dataset.dialogReady)return;
      help.dataset.dialogReady='true';
      help.querySelectorAll('[data-fb-help]').forEach(button => {
        const dialog=help.querySelector('[data-fb-help-dialog="'+button.dataset.fbHelp+'"]');
        button.addEventListener('click',()=>dialog.showModal());
        dialog.querySelector('[data-fb-help-close]').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('keydown',event=>{
          if(event.key!=='Tab')return;
          const items=[...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
          const first=items[0],last=items[items.length-1];
          if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
          else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
        });
        dialog.addEventListener('click',event=>{
          const r=dialog.getBoundingClientRect();
          if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))dialog.close();
        });
        dialog.addEventListener('close',()=>button.focus());
      });
    });
  };
  const init = () => { initHeader(); initPurchase(); initGallery(); initCompactPurchase(); initReviews(); initHelp(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
